import { render, staticRenderFns } from "./RolesDrawerMain.vue?vue&type=template&id=191d0763&scoped=true&"
import script from "./RolesDrawerMain.vue?vue&type=script&lang=js&"
export * from "./RolesDrawerMain.vue?vue&type=script&lang=js&"
import style0 from "./RolesDrawerMain.vue?vue&type=style&index=0&id=191d0763&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191d0763",
  null
  
)

export default component.exports